/* eslint-disable */
const ComponentThatAllowSubmitByPressingEnter = () => {
  return <button className="display-none" />;
};
export default ComponentThatAllowSubmitByPressingEnter;
